import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import dealerService from "../services/dealer.service";

import EventBus from "../utils/EventBus";


export const getdealerbyid = createAsyncThunk(
  "api/getdealerbyid",
  async ( thunkAPI) => {
    try {
      const data = await dealerService.getDealerbyid();
      return { dealerdata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updatedealer = createAsyncThunk(
  "api/updatedealer",
  async ({dealer_id, formData}, thunkAPI) => {
    try {
      const data = await dealerService.updateDealer(dealer_id, formData);
      return { dealerdata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState ={
    dealer: null,
    message:""
}

const dealerSlice = createSlice({
  name: "api",
  initialState,
  extraReducers: {
  [getdealerbyid.fulfilled]: (state, action) => {
    state.dealer = action.payload.dealerdata.data[0]
    return state;
  },
  [getdealerbyid.rejected]: (state, action) => {
    state.message = action.payload.dealerdata.message
    return state;
  },
  [updatedealer.fulfilled]: (state, action) => {
    const {
      arg: { dealer_id },
    } = action.meta;
    if (dealer_id) {
      state.dealer = action.payload.dealerdata.data
    };
    state.message = action.payload.dealerdata.message
  },
  [updatedealer.rejected]: (state, action) => {
    state.message = action.payload.dealerdata.message
  },
  },
});

const { reducer } = dealerSlice;
export default reducer;